import { useQuery } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase, objNamesToSnakeCase } from "common/utils/helpers/cases";
import type { ID, print } from "common/utils/models";

export type EstimatedDeliveryResult = {
  compositionDates: print.estimatedDelivery.CompositionDates | undefined;
  isOutOfStock: boolean;
};

export function useEstimatedDelivery(compositionId?: ID) {
  return useQuery({
    enabled: !!compositionId,
    queryKey: ["estimatedDelivery", compositionId],
    queryFn: async (): Promise<EstimatedDeliveryResult | undefined> => {
      if (!compositionId) return undefined;

      const requestParams: print.estimatedDelivery.Request = {
        compositionId
      };

      const res = await api.print
        .estimatedDelivery(objNamesToSnakeCase(requestParams))
        .then(objNamesToCamelCase);

      if (res && res.success) {
        return {
          compositionDates: res.compositionDates,
          isOutOfStock: false
        };
      }

      if (res && res.outOfStock) {
        return {
          compositionDates: undefined,
          isOutOfStock: true
        };
      }

      return undefined;
    }
  });
}
